import React, { useEffect, useRef, useState } from 'react'
import { toast } from 'react-toastify'
import { Loading, Section } from '../../components'
import { SourcingAuctionSupplierStyle } from './styled'

// Helpers
import { localStorageService, ROUTE_PATH, toastFail } from '../../helpers'

// Constants
import { SubmitBid } from './constants/SubmitBid'

//Element
import TimeLeftBid from './element/TimeLeftBid'
import ButtonBack from './element/ButtonBack'
import Title from './element/Title'
import AuctionInformation from './element/AuctionInformation'
import AuctionLeadingBid from './element/AuctionLeadingBid'
import ModalSubmitBid from './element/ModalSubmitBid'
import ModalHistoryOfSupplier from './element/ModalHistoryOfSupplier'
import BidHistoryOfSupplier from './element/BidHistoryOfSupplier'
import ModalTimeOut from './element/ModalTimeOut'

// Core
import { ENV_CONFIG } from '../../core/config'
import { SocketIO } from '../../core'

// Socket Component
import { SIOEvent } from '../../components/socket/SIOEvent'
import { SIOSocket } from '../../components/socket/SIOSocket'
import { SIOBidding } from '../../components/socket/SIOBidding'

// Service
import auctionService from '../../apiService/services/auctionService'
import { mySupplierCompanyController } from '../../apiService'

// Store
import { store } from '../../store'
import { generatePath } from 'react-router'
import { controller } from '../../middleware'

const SourcingAuctionSupplierContainer = props => {
  const { match } = props
  const { params } = match
  const sourcingID = params ? params.sourcingid : ''
  const isMounted = useRef(false)
  const [modals, setModals] = useState([
    { name: 'modals-history-of-supplier', isOpen: false },
    { name: 'modals-submit-bid-fail', isOpen: false },
    { name: 'modals-submit-bid', isOpen: false },
  ])
  const [eventData, setEventData] = useState({})
  const [timeLeft, setTimeLeft] = useState([])
  const [totalBidAmount, setTotalBidAmount] = useState(0)
  const [submitStatusId, setSubmitStatusId] = useState(1)
  const [leading, setLeading] = useState({
    userID: '0',
    price: 0,
  })
  const [itemsList, setItemsList] = useState([])
  const [bidHistory, setBidHistory] = useState([])
  const [bidHistoryId, setBidHistoryId] = useState([])
  const [bidHistoryForCheck, setBidHistoryForCheck] = useState([])
  const [itemBidHistory, setItemBidHistory] = useState([])
  const [bidDecrementIncrement, setBidDecrementIncrement] = useState('')
  const [submitBidStatus, setSubmitBidStatus] = useState(
    SubmitBid.SUBMIT_BIT_STATUS.FAIL
  )
  const userId = localStorageService.getBuyerId()
  const { role } = store.getState()
  const apiRedirectPath = ROUTE_PATH.SOURCING_SUPPLIER.LINK
  const [biddingStatus, setBiddingStatus] = useState('')
  const prevBiddingStatusRef = useRef()
  const [redirectPathEvent, setRedirectPathEvent] = useState('')
  const [isLoading, setIsLoading] = useState(true)
  const isHistoryChange = useRef(false)
  const [tokenVerified, setTokenVerified] = useState(false)

  const cleanUp = () => {
    // setItemsList([])
    setTokenVerified(false)
    setBidHistory([])
    setBidHistoryId([])
    setItemBidHistory([])
    setBidDecrementIncrement('')
  }

  useEffect(async () => {
    isMounted.current = true
    setIsLoading(true)
    const tokenPass = await checkToken()
    setIsLoading(false)
    setTokenVerified(tokenPass)

    if (!tokenPass) {
      controller().redirectToLogin()
      return cleanUp
    }

    return cleanUp
  }, [])

  useEffect(async () => {
    if (!isLoading) {
      checkAuctionData()
    }

    return cleanUp
  }, [tokenVerified, biddingStatus])

  useEffect(async () => {
    console.log({ isLoading })
    if (!isLoading && eventData) {
      await updateHistory(eventData.event_id)
    }

    // if (isLoading && sourcingID) {
    //   await getAuctionItemList(sourcingID)
    // }

    return cleanUp
  }, [leading])

  const checkAuctionData = async () => {
    if (!tokenVerified) {
      return
    }

    setIsLoading(true)
    const resp = await auctionService.getAuctionBySupplier(sourcingID)
    if (resp === '57004: unauthorized, supplier was not invited') {
      toastFail('Access deny')
      props.history.push('')
    } else {
      await getSupplierEvent()
    }
    setIsLoading(false)
  }

  const checkToken = async () => {
    const tokens = new URLSearchParams(props.location.search).get('token')
    if (tokens) {
      // console.log('tokens', tokens)
      try {
        const resToken = await mySupplierCompanyController().getVerifyToken(
          tokens
        )
        if (resToken && resToken.is_verify) {
          return true
        } else {
          toastFail(resToken.message)
          return false
        }
      } catch (e) {
        return false
      }
    } else {
      return true
    }
  }

  const getSupplierEvent = async () => {
    if (!sourcingID) {
      props.history.push(ROUTE_PATH.SOURCING_BUYER.LINK)
    } else {
      await getEventData(sourcingID)
      await getAuctionItemList(sourcingID)
    }
  }

  const getEventData = async id => {
    const resp = await auctionService.getAuctionBySupplierID(id)
    if (resp) {
      if (resp.auction_status_id === 3) {
        setEventData(resp)
        setBidDecrementIncrement(
          resp.bid_decrement_increment || resp.min_bid_decrement_increment
        )
        setRedirectPathEvent(
          generatePath(ROUTE_PATH.SOURCING_DETAIL_SUPPLIER_FORM.LINK, {
            id: resp.event_id,
          })
        )
        await updateHistory(resp.event_id)
      } else {
        if (biddingStatus !== 'close' && prevBiddingStatusRef !== 'close') {
          props.history.push(
            generatePath(ROUTE_PATH.SOURCING_DETAIL_SUPPLIER_FORM.LINK, {
              id: resp.event_id,
            })
          )
        }
      }
    }
  }

  const getHistoryOfSupplier = async (id, userId) => {
    const resp = await auctionService.getBidHistoryOfSupplierByEventIdNUserId(
      id,
      userId
    )
    // console.log({ resp, bidHistory })
    if (resp) {
      isHistoryChange.current = bidHistory.length !== resp.length
      setBidHistory(resp)
    }
  }

  const getItemOfBidHistory = async eventId => {
    let item_suppliers = []
    const oldItem = await auctionService.getAuctionItemBySupplierID(sourcingID)
    if (oldItem) {
      if (oldItem !== '57004: unauthorized, supplier was not invited') {
        item_suppliers = oldItem.item_suppliers.map(item => {
          return {
            ...item,
            total_price: item.total_price ? item.total_price : 0,
            unit_price: item.unit_price ? item.unit_price : 0,
            auction_supplier_item_file: item.auction_supplier_item_file.map(
              j => ({
                id: j.id,
                name: j.name,
                is_delete: false,
              })
            ),
          }
        })
      }

      const newItem = await auctionService.getItemsBidHistoryOfSupplierByEventIdNUserId(
        eventId,
        userId
      )
      if (newItem) {
        for (let i = 0; i < newItem.length; i++) {
          newItem[i].items.map((val, j) => {
            item_suppliers.map(value => {
              if (value.auction_item_id === val.id) {
                newItem[i].items[j] = {
                  ...newItem[i].items[j],
                  description: value.description,
                  uom: value.uom,
                  name: value.name,
                }
              }
            })
          })
        }
        // console.log({ isHistoryChange })
        if (isHistoryChange.current) {
          setBidHistoryForCheck(newItem)
        }
        setItemBidHistory(newItem)
      }
    }
  }

  const updateHistory = async eventId => {
    if (tokenVerified) {
      getHistoryOfSupplier(eventId, userId)
      getItemOfBidHistory(eventId)
    }
  }

  const getAuctionItemList = async id => {
    let item_suppliers = []
    const resp = await auctionService.getAuctionItemBySupplierID(id)
    // console.log('resp', resp)
    if (resp) {
      if (resp !== '57004: unauthorized, supplier was not invited') {
        item_suppliers = resp.item_suppliers.map(item => {
          return {
            ...item,
            total_price: item.total_price ? item.total_price : null,
            unit_price: item.unit_price ? item.unit_price : null,
            auction_supplier_item_file: item.auction_supplier_item_file.map(
              j => ({
                id: j.id,
                name: j.name,
                is_delete: false,
              })
            ),
          }
        })
        setItemsList(item_suppliers)
      }
    }
  }

  const toggleModal = id => {
    if (isMounted.current) {
      const mapValue = modals.map(modal => ({
        ...modal,
        isOpen: modal.name === id ? !modal.isOpen : false,
      }))
      return setModals(mapValue)
    }
  }

  const handlersClose = () => {
    return toggleModal()
  }

  const send = () => {
    handlersClose()
    setIsLoading(true)
    let newItem = Array()
    let totalPrice = 0
    if (itemsList) {
      itemsList.map(value => {
        newItem.push({
          id: value.auction_item_id,
          supplier_id: userId,
          qty: value.req_amount,
          price: value.unit_price,
          total: value.total_price,
        })
        totalPrice = value.total_price + totalPrice
      })
    }
    if (newItem) {
      // console.log('test')
      SocketIO.emit(
        'bidding',
        {
          room: `auction_${eventData.event_no}`,
          price: totalBidAmount ? totalBidAmount : totalPrice,
          type: eventData.bidding_type === 'Reverse' ? 1 : 2,
          item: newItem,
        },
        async response => {
          // console.log(response, 'response bid') // ok
          const { success, current_bidding } = response
          if (success) {
            // console.log('SUCCESS')
            setLeading({
              userID: current_bidding.leading.toString(),
              price: current_bidding.price,
            })
            await updateHistory(eventData.event_id, userId)
            toast.success(' Submit Bid successfully')
          } else {
            // console.log('FAIL')
            toast.error(
              'Your latest bid submission is not accepted, please re-submit new bid'
            )
          }
        }
      )
    }
    setIsLoading(false)
  }

  const onBiddingTime = data => {
    if (data) {
      if (data.price === 0 || data.price > 0) {
        setLeading({
          userID: data.leading ? data.leading.toString() : '0',
          price: data.price ? data.price : 0,
        })
      } else {
        setTimeLeft(data)
      }
    }
  }

  const SocRoom = () => {
    console.log('Connected') // connect successfully

    SocketIO.emit(
      'bidding-lead',
      {
        room: `auction_${eventData.event_no}`,
        event_no: eventData.event_no,
      },
      response => {
        if (response.event_no === eventData.event_no) {
          setLeading({
            userID: response.leading.toString(),
            price: response.price,
          })
        }
      }
    )
  }

  const SocStatusBidding = data => {
    // console.log('Status : ', data) // connect successfully
    if (data) {
      if (data === 'invalid time') {
        //go to another screen
        toast.error('Invalid Time')
        props.history.replace(apiRedirectPath)
      }
      if (data === 'close') {
        setBiddingStatus(data)
        prevBiddingStatusRef.current = data
      }
    }
  }

  const SocAuctionLeaderUpdated = data => {
    if (!data) return

    const leader = data.leader || {}
    setLeading({
      userID: leader.user_id ? leader.user_id.toString() : '0',
      price: leader.price || 0,
    })
  }

  const SocOnDisconnected = reason => {
    if (reason === 'transport close') {
      toast.error('Please check internet connection and reload the page.', {
        delay: 6,
      })
    } else if (reason === 'io server disconnect') {
      toast.error('Disconnect', {
        delay: 6,
      })
    }
    props.history.replace(apiRedirectPath)
  }

  return (
    <React.Fragment>
      <Loading loading={isLoading} spinner={isLoading} />
      {tokenVerified && eventData.event_no && (
        <SourcingAuctionSupplierStyle>
          <ButtonBack props={props} apiRedirectPath={apiRedirectPath} />
          <Section className="auction-wrapper">
            <Title />
            <AuctionInformation eventData={eventData} />
            {eventData.event_no && (
              <SIOSocket options={ENV_CONFIG.socketIO}>
                <SIOEvent
                  on="connect"
                  callback={SocRoom}
                  room={{
                    event: `auction_${eventData.event_no}`,
                    userID: `S_${localStorageService.getBuyerId()}`,
                  }}
                  member={false}
                />
                <SIOEvent on="event-status" callback={SocStatusBidding} />
                <SIOEvent
                  on="auction_leader_updated"
                  callback={SocAuctionLeaderUpdated}
                />
                <SIOEvent on="disconnect" callback={SocOnDisconnected} />

                <SIOBidding callback={onBiddingTime} />
                <TimeLeftBid timeLeft={timeLeft} />
                <AuctionLeadingBid
                  itemsList={itemsList}
                  totalBidAmount={totalBidAmount}
                  leading={leading}
                  eventData={eventData}
                  setItemsList={setItemsList}
                  bidDecrementIncrement={bidDecrementIncrement}
                  setTotalBidAmount={setTotalBidAmount}
                  setSubmitBidStatus={setSubmitBidStatus}
                  toggleModal={toggleModal}
                  setSubmitStatusId={setSubmitStatusId}
                  itemBidHistory={bidHistoryForCheck[0]}
                  loadingViewBid={false}
                  setIsLoading={setIsLoading}
                  isHistoryChange={isHistoryChange.current}
                />
                <BidHistoryOfSupplier
                  toggleModal={toggleModal}
                  eventData={eventData}
                  bidHistory={bidHistory}
                  leading={leading}
                  userId={userId}
                  setBidHistoryId={setBidHistoryId}
                />
              </SIOSocket>
            )}
          </Section>
          {modals[0].isOpen && (
            <ModalHistoryOfSupplier
              modals={modals}
              itemBidHistory={[itemBidHistory[bidHistoryId]]}
              eventData={eventData}
              role={role}
              bidHistoryId={bidHistoryId}
              bidHistoryLength={itemBidHistory.length}
              handlersClose={handlersClose}
            />
          )}
          {(modals[1].isOpen || modals[2].isOpen) && (
            <ModalSubmitBid
              modals={modals}
              submitStatusId={submitStatusId}
              eventData={eventData}
              totalBidAmount={totalBidAmount}
              handlersClose={handlersClose}
              submitBidStatus={submitBidStatus}
              send={send}
              leading={leading}
            />
          )}
          {/*check auction status is close and time out*/}
          {biddingStatus && (
            <ModalTimeOut
              timeOut={!!biddingStatus}
              props={props}
              handlersClose={handlersClose}
              apiRedirectPath={redirectPathEvent}
            />
          )}
        </SourcingAuctionSupplierStyle>
      )}
    </React.Fragment>
  )
}

export { SourcingAuctionSupplierContainer }

export default SourcingAuctionSupplierContainer
